import chroma from 'chroma-js';
export const point_style_options = [
  {
    value: 'circle',
    text: 'circle',
  },
  {
    value: 'cross',
    text: 'cross',
  },
  {
    value: 'crossRot',
    text: 'crossRot',
  },
  {
    value: 'dash',
    text: 'dash',
  },
  {
    value: 'line',
    text: 'line',
  },
  {
    value: 'rect',
    text: 'rect',
  },
  {
    value: 'rectRounded',
    text: 'rectRounded',
  },
  {
    value: 'rectRot',
    text: 'rectRot',
  },
  {
    value: 'star',
    text: 'star',
  },
  {
    value: 'triangle',
    text: 'triangle',
  },
  {
    value: 'false',
    text: 'false',
  },
];

export const chart_type_options = [
  {
    value: 'bar',
    text: '막대',
  },
  {
    value: 'pie',
    text: 'pie',
  },
  {
    value: 'doughnut',
    text: '도넛',
  },
  {
    value: 'line',
    text: '라인',
  },
  {
    value: 'polarArea',
    text: '폴라',
  },
  {
    value: 'radar',
    text: 'radar',
  },
];

export const legend_position_options = [
  {
    value: 'top',
    text: 'top',
  },
  {
    value: 'left',
    text: 'left',
  },
  {
    value: 'bottom',
    text: 'bottom',
  },
  {
    value: 'right',
    text: 'right',
  },
  {
    value: 'chartArea',
    text: 'chartArea',
  },
];

export const align_options = [
  {
    value: 'start',
    text: 'start',
  },
  {
    value: 'center',
    text: 'center',
  },
  {
    value: 'end',
    text: 'end',
  },
];

export const y_options = [
  {
    text: '(좌측) Y축',
    value: 'y-axis',
  },
  {
    text: '(우측) Y축',
    value: 'y-axis-right',
  },
];

export function getColorScheme(
  baseColor,
  num = 5,
  is_random = true,
  hue = 0, // 기본 hue 조정 x (0~0.1)
  saturation = 0, // 기본 saturation 조정 x (0~0.1)
  lightness = 0 // 기본 lightness 조정 x (0~0.1)
) {
  /**
   * 5개의 어울리는 색상 리스트를 생성
   * num: 생성 랜덤 컬러 개수 (return Array의 length)
   * is_random: 색상을 랜덤하게 return
   * return Array
   */

  if (is_random) {
    const colors = new Set();

    while (colors.size < num) {
      const randomSaturation =
        saturation > 0 ? saturation + Math.random() * (1 - saturation) : Math.random();
      const randomLightness =
        lightness > 0 ? lightness + Math.random() * (1 - lightness) : Math.random();

      const color = chroma(baseColor)
        .set('hsl.s', randomSaturation)
        .set('hsl.l', randomLightness)
        .hex('rgba');
      colors.add(color);
    }
    return Array.from(colors);
  } else {
    const colors = chroma
      .scale([baseColor, 'white'])
      .mode('lab')
      .colors(num)
      .map((color) => chroma(color).hex('rgba'));
    return Array.from(new Set(colors));
  }
}
